import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Page not found | Amanah Promotions");
  return (
    <section className="bg-white">
      <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col justify-center px-6 py-24 sm:px-10 lg:px-16">
        <span className="font-display text-6xl font-medium text-brand-green">404</span>
        <h1 className="mt-4 font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-slate-body">
          The page you were looking for could not be found. It may have moved, or the link may be
          incorrect.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-brand-green hover:text-brand-greenDeep"
          data-testid="notfound-home-link"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to homepage
        </Link>
      </div>
    </section>
  );
}
